import {Holiday, HolidayRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {Grid, TableCell} from "@mui/material";
import {dateFromToString} from "../../../../components/utils/dates";
import {CALENDAR_LABELS} from "./labels";

export const HolidayListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<Holiday> = {
        title: "Días festivos",
        onClick: "/app/admin/employee/holiday",
        headers: [
            {title: "Calendario"},
            {title: "Fecha"},
            {title: "Descripción"},
        ],
        decorator: (bean: Holiday) => (
            < >
                <TableCell>
                    {CALENDAR_LABELS[bean.calendar || ""] || bean.calendar}
                </TableCell>
                <TableCell>
                    {dateFromToString(bean.holidayDate)}
                </TableCell>
                <TableCell>
                    {bean.description}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(HolidayRestControllerApiFactory);
            return ctrl.pageHoliday(
                currentPage,
                size,
                undefined,
                undefined,
                term,
                showDismissed
            );
        },
    };

    return (
        <>
            <AppList config={listConfig} />
        </>
    );
};